import { UrlParserRegex } from './models/ParsedUrl';
export function getLocation(url) {
    if (url && url.length) {
        var match = url.match(UrlParserRegex);
        if (match) {
            return {
                href: url,
                protocol: match[1],
                host: match[2],
                hostname: match[3],
                port: match[4],
                path: match[5],
                search: match[6],
                hash: match[7],
            };
        }
    }
    return undefined;
}
//# sourceMappingURL=getLocation.js.map